export default __webpack_public_path__ + "static/media/210.04349137.png";